'use client';

import { buildAmplitudeTracker, trackGTMEvent } from '@curology/site-tools';

import COOKIE_KEYS from '@/consts/cookieKeys';
import {
  AnalyticsEvent,
  type AnalyticsPayload,
  FlowTypes,
} from '@/consts/events';
import {
  type AnalyticsPatient,
  type TraitsType,
} from '@/types/metrics/analyticsPatient';
import cookie from '@/utils/cookies/client';
import { trackFeature } from '@/utils/featureFlags/client';

const { getDeviceId, getDeviceIdQueryObj, flushEvents } = buildAmplitudeTracker<
  AnalyticsEvent,
  AnalyticsPayload
>();

const trackEvent = (
  event: AnalyticsEvent,
  payload?: valueof<AnalyticsPayload>,
  options?: {
    gtm?: {
      spreadProperties: boolean;
    };
  },
) => {
  // TODO: Track via site tool Amplitude Browser SDK implmentation once GTM collisions are handled
  trackGTMEvent(event, payload, options?.gtm);
  trackFeature(event, payload);
};

const getAmplitudeDeviceId = (): string | undefined => {
  return cookie.get(COOKIE_KEYS.amplitudeDeviceId) ?? getDeviceId();
};

const identifyUser = ({
  patient,
  traits = {},
  callback,
}: {
  patient: AnalyticsPatient;
  traits?: TraitsType;
  callback?: () => void;
}): void => {
  trackGTMEvent(
    AnalyticsEvent.IDENTIFY,
    {
      patient,
      traits,
    },
    {
      spreadProperties: true,
    },
  );

  if (typeof callback === 'function') {
    setTimeout(callback, 300);
  }
};

export {
  getAmplitudeDeviceId,
  getDeviceIdQueryObj,
  flushEvents,
  identifyUser,
  trackEvent,
  AnalyticsEvent,
  type AnalyticsPayload,
  FlowTypes,
};
